module.exports = {
  'www.ticketswap.com': 'en',
  'www.ticketswap.nl': 'nl-NL',
  'www.ticketswap.fr': 'fr-FR',
  'www.ticketswap.de': 'de-DE',
  'www.ticketswap.es': 'es-ES',
  'www.ticketswap.hu': 'hu-HU',
  // Country-specific language variants
  'www.ticketswap.uk': 'en-GB',
  'www.ticketswap.ie': 'en-IE',
  'www.ticketswap.be': 'nl-BE',
  'fr.ticketswap.be': 'fr-BE',
  'www.ticketswap.ch': 'de-CH',
  'fr.ticketswap.ch': 'fr-CH',
  'www.ticketswap.at': 'de-AT',
  'www.ticketswap.com.au': 'en-AU',
  'www.ticketswap.com.br': 'pt-BR',
}
